import { PagedData } from "@/services/models/shared/PagedData";
import { AxiosResponse } from "axios";
import {
  NetworkIDT,
  NetworkIDTFilterOptions,
  NetworkIDTListItem,
  NewNetworkIDT,
  UpdateNetworkIDT,
} from "@/services/models/NetworkIDT";
import BimsHttpService from "@/services/BimsHttpService";
import FileProvider from "@/utilities/providers/FileProvider";

class NetworkIDTService {
  /**
   * @description Returns a paged list of network IDTs.
   */
  getNetworkIDTs(
    filter: NetworkIDTFilterOptions
  ): Promise<PagedData<NetworkIDTListItem>> {
    return BimsHttpService.get(`/networkIDTs`, {
      params: filter,
    }).then((response: AxiosResponse<PagedData<NetworkIDTListItem>>) => {
      return response.data as PagedData<NetworkIDTListItem>;
    });
  }

  /**
   * @description Returns the network IDT with the specified SL, SA, and Famis Department
   */
  getNetworkIDT(
    sl: string,
    sa: string,
    famisDepartment: string
  ): Promise<NetworkIDT> {
    return BimsHttpService.get(`/networkIDTs/specificNetworkIDT`, {
      params: { sl, sa, famisDepartment },
    }).then((response: AxiosResponse<NetworkIDT>) => {
      return response.data as NetworkIDT;
    });
  }
  /**
   * @description Adds a new network IDT
   */
  addNetworkIDT(networkIDT: NewNetworkIDT): Promise<any> {
    return BimsHttpService.post(`/networkIDTs`, networkIDT);
  }

  /**
 * @description Updates the network IDT
 */
  updateNetworkIDT(networkIDT: UpdateNetworkIDT): Promise<any> {
    return BimsHttpService.put(`/networkIDTs`, networkIDT);
  }

  /**
 * @description Checks if any Network IDT Numbers exist and returns the list.
 */
  checkNetworkIDTNumbersExist(): Promise<{ exists: boolean; networkIDTNumbers: any[] }> {
    return BimsHttpService.get(`/networkIDTs/numbers/check`)
      .then((response: AxiosResponse<{ exists: boolean; networkIDTNumbers: any[] }>) => {
        return response.data;
      });
  }

  /**
   * @description Creates a new Network IDT Number.
   */
  createNetworkIDTNumber(idtNumber: string): Promise<boolean> {
    return BimsHttpService.post(`/networkIDTs/numbers`, {
      IDTNumber: idtNumber,
    });
  }
  /**
   * @description Fetches the total amount charged from the backend.
   */
  getTotalAmountCharged(): Promise<number> {
    return BimsHttpService.get(`/networkIDTs/totalAmountCharged`)
      .then((response: AxiosResponse<number>) => {
        return response.data;
      });
  }

  /**
   * @description Downloads the CSV export for the base account listing
   */
  public downloadNetworkIDTFrozenAndMissingAccounts(): Promise<any> {
      return BimsHttpService.get(`/networkIDTs/accounts/frozenAndMissing/report`).then(response => {
          return FileProvider.ForceFileDownload(response)
      })
  }
}

export default new NetworkIDTService();
